import { ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import CommonComponents from "../components/Commons";

import { RootState } from "../store/store";
import NotificationBell from "./NotificationBell";

import FlagEN from "../assets/flags/en.png";
import FlagVN from "../assets/flags/vi.png";

interface IProps
{
  header?: ReactNode;
  footer?: ReactNode;
  children: ReactNode;
  zIndex?: number;
  headerZIndex?: number;
  bodyZIndex?: number;
  footerZIndex?: number;
  pageName?: any;
  overlay?: boolean;
}

export default function ContentLayoutManagement({
  header,
  footer,
  children,
  zIndex = 20,
  headerZIndex = 20,
  bodyZIndex = 10,
}: IProps)
{
  const loadingGlobal = useSelector(
    (state: RootState) => state.appCommonSlice.loadingGlobal,
  );

  const { expanded } = useSelector((state: RootState) => state.layoutSlice);
  const { showDrawer, showBottomDrawer, bottomDrawerType } = useSelector(
    (state: RootState) => state.drawerSlice,
  );

  const { t, i18n } = useTranslation();

  const [language, setLanguage] = useState(
    localStorage.getItem("language") || "vi",
  );

  const _header = (
    <div
      className={`h-14 py-2  w-full flex flex-row items-center bg-[var(--color-bg-nav)]`}
    >
      {header}

      {loadingGlobal && (
        <svg
          className="animate-spin mr-6"
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <circle
            cx="12"
            cy="12"
            r="10"
            transform="rotate(45 12 12)"
            stroke="#565656"
            stroke-width="3"
          />
          <path
            d="M19.0708 19.0711C15.1656 22.9763 8.83395 22.9763 4.92871 19.0711C1.02347 15.1658 1.02347 8.8342 4.92871 4.92896"
            stroke="#60CDFF"
            strokeWidth="3"
            strokeLinecap="round"
          />
        </svg>
      )}
    </div>
  );

  const renderBottomDrawer = () =>
  {
    switch (bottomDrawerType)
    {


      default:
        break;
    }
  };

  return (
    <div
      className="absolute w-full h-full left-0 top-0  flex flex-col"
      style={{ zIndex: zIndex }}
    >
      <div
        className={`flex justify-between items-center !min-h-[74px] !h-[74px] bg-[var(--color-bg-nav)] px-8`}
        style={{ zIndex: headerZIndex, borderBottom: "1px solid #2B364F" }}
      >
        {_header}

        <div className="flex items-center gap-4">
          {/* notification */}
          <NotificationBell />

          {/* language */}

          <CommonComponents.SelectUI
            className="w-[90px] h-10 !rounded-[100px] custimse-select-lang"
            value={language}
            optionLabelProp="label"
            onChange={(value) =>
            {
              window.localStorage.setItem("language", value);
              i18n.changeLanguage(value);
              setLanguage(value);
            }}
            options={[
              {
                label: (
                  <div className="flex items-center gap-2">
                    <img
                      src={FlagEN}
                      alt="en"
                      className="w-5 h-5 rounded-full"
                    />
                    <span>EN</span>
                  </div>
                ),
                value: "en",
              },
              {
                label: (
                  <div className="flex items-center gap-2">
                    <img
                      src={FlagVN}
                      alt="vi"
                      className="w-5 h-5 rounded-full"
                    />
                    <span>VN</span>
                  </div>
                ),
                value: "vi",
              },
            ]}
          />
        </div>
      </div>

      <div
        className={`grow overflow-auto bg-[var(--color-bg-content)]`}
        style={{
          zIndex: bodyZIndex,
          height: "calc(100vh - 74px)",
          width: expanded ? "calc(100vw - 268px)" : "calc(100vw - 74px)",
        }}
      >
        <>
          <div
            style={{
              width: showDrawer ? "calc(100% - 460px)" : "100%",
              height: "calc(100vh - 74px)",
            }}
          >
            {children}
          </div>

          {/* {showBottomDrawer && (
            <div
              className="absolute bottom-[56px] h-fit z-20 transition-all duration-300"
              style={{
                width: showDrawer ? "calc(100% - 460px)" : "100%",
              }}
            >
              <CommonComponents.DrawerUI
                open={showBottomDrawer}
                placement="bottom"
              >
                {renderBottomDrawer()}
              </CommonComponents.DrawerUI>
            </div>
          )} */}
        </>
      </div>

      {/* <div className="flex-none h-fit" style={{ zIndex: footerZIndex }}>
        {_footer}
      </div> */}
    </div>
  );
}
